import {
    GET_ROLE,
    SET_ROLE,
    SET_APIMKEY,
    GET_APIMKEY,
    GET_DETAILS,
    SET_DETAILS,
    SET_URGENCY,
    SET_NOOFRECIPIENT,
    SET_REASONCODE,
    // SET_REASONINBRIEF,
    SET_SOURCE,
    SET_TEMPLATE,
    SET_STATUSGRID,
    SET_EDL_UPLOADED,
    SET_TEMPLATECONTENT,
    SET_SAVEREQUEST,
    SET_SAVETEMPLATE,
    SET_EDITTEMPLATE,
    SET_SENDFORAPPROVAL,
    SET_REQUESTDETAILS,
    SET_ASSIGNTOME,
    SET_APPROVERSGRID,
    SET_APPROVEORDECLINE,
    SET_USETEMPLATECONTENT,
    SET_TEMPALTEDLLIST,
    SET_FILEUPLOADERRMSG,
    SET_DELETE_REQUEST,
    SET_DELETE_TEMPLATE,
    SET_CANCEL_ERROR,
    SET_ACTIVE_STATUS

} from './massMailerAction';

const initialState = {
    activeStatus: "",
    templateDlList: {},
    isEDlUploaded: 0,
    cancelError: "",
    cancelErrorStatus: "",
    role: '',
    source: [],
    reasonCode: [],
    template: [],
    urgency: '',
    resonInBrief: '',
    noOFRecipient: '',
    statusGrid: [],
    isSearchEnabled: false,
    templateContent: "",
    saveRequest: "",
    saveTemplate: "",
    editTemplate: "",
    sendForApproval: "",
    requestDetails: "",
    assignToMe: [],
    appoversGrid: [],
    approveOrDecline: "",
    useTemplateContent: {},
    fileUploadErrMsg: "",
    deleteRequest: "",
    deleteTemplate: ""

};
const massMailer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CANCEL_ERROR:
            return Object.assign({}, state, {
                cancelError: action.msg,
                cancelErrorStatus: action.status
            })
        case SET_EDL_UPLOADED:
            return Object.assign({}, state, {
                isEDlUploaded: action.value
            })
        case GET_ROLE:
            return Object.assign({}, state, {
                role: action.value
            })
        case SET_ACTIVE_STATUS:
            return Object.assign({}, state, {
                activeStatus: action.value
            })
        case SET_ROLE:
            return Object.assign({}, state, {
                role: action.value
            })
        case GET_APIMKEY:
            return Object.assign({}, state, {
                key: action.value
            })
        case SET_APIMKEY:
            return Object.assign({}, state, {
                key: action.value
            })
        case GET_DETAILS:
            return Object.assign({}, state, {
                details: action.value
            })
        case SET_DETAILS:
            return Object.assign({}, state, {
                details: action.value
            })

        case SET_SOURCE:
            return Object.assign({}, state, {
                source: action.value
            })
        case SET_REASONCODE:
            return Object.assign({}, state, {
                reasonCode: action.value
            })
        case SET_TEMPLATE:
            return Object.assign({}, state, {
                template: action.value
            })
        case SET_URGENCY:
            return Object.assign({}, state, {
                urgency: action.value
            })
        case SET_NOOFRECIPIENT:
            return Object.assign({}, state, {
                noOFRecipient: action.value
            })
        case SET_STATUSGRID:
            return Object.assign({}, state, {
                statusGrid: action.value
            })
        case SET_TEMPLATECONTENT:
            return Object.assign({}, state, {
                templateContent: action.value
            })
        case SET_SAVEREQUEST:
            return Object.assign({}, state, {
                saveRequest: action.value
            })
        case SET_EDITTEMPLATE:
            return Object.assign({}, state, {
                editTemplate: action.value
            })
        case SET_SAVETEMPLATE:
            return Object.assign({}, state, {
                saveTemplate: action.value
            })
        case SET_SENDFORAPPROVAL:
            return Object.assign({}, state, {
                sendForApproval: action.value
            })
        case SET_REQUESTDETAILS:
            return Object.assign({}, state, {
                requestDetails: action.value
            })
        case SET_APPROVERSGRID:
            return Object.assign({}, state, {
                appoversGrid: action.value
            })
        case SET_ASSIGNTOME:
            return Object.assign({}, state, {
                assignToMe: action.value
            })
        case SET_APPROVEORDECLINE:
            return Object.assign({}, state, {
                approveOrDecline: action.value
            })
        case SET_USETEMPLATECONTENT:
            return Object.assign({}, state, {
                useTemplateContent: action.value
            })
        case SET_TEMPALTEDLLIST:
            return Object.assign({}, state, {
                templateDlList: action.value
            })
        case SET_FILEUPLOADERRMSG:
            return Object.assign({}, state, {
                fileUploadErrMsg: action.value
            })
        case SET_DELETE_REQUEST:
            return Object.assign({}, state, {
                deleteRequest: action.value
            })
        case SET_DELETE_TEMPLATE:
            return Object.assign({}, state, {
                deleteTemplate: action.value
            })
        default:
            return state;
    }
}
export default massMailer;